import { percentValue } from "../../helpers/operationMath";

export const ContainerCardsCategories = ({ data = [], extraClass = "" }) => {
	const totalProyects = data.reduce((total, child) => {
		return total + child.children.reduce((childTotal, newC) => childTotal + newC.count, 0);
	}, 0);
	return (
		<section className={`w-full grid grid-cols-[repeat(auto-fit,_minmax(240px,_1fr))] gap-6 ${extraClass}`}>
			{data.map((category, index) => {
				const { color: categoryColor = "#ccc", name: categoryName, children: categoryChildren } = category;
				let totalProyectsByCategory = 0;

				const newChild = categoryChildren.map((project, i) => {
					totalProyectsByCategory += project.count;
					const { color: projectColor = categoryColor, nameId: projectName, count: projectCount } = project;
					const percentage = percentValue(totalProyects, projectCount);

					return (
						<div key={`${i}-newc`} className="flex items-center justify-between py-[4px] px-3 text-[11px]">
							<div className="flex items-center w-7/12">
								<div className="w-3 h-3 rounded-full mr-1" style={{ backgroundColor: projectColor }} />
								<p className="font-semibold">{projectName}</p>
							</div>
							<p className="text-end w-2/12">{projectCount}</p>
							<p className="text-end w-3/12">{percentage}%</p>
						</div>
					);
				});

				return (
					<div key={`${index}-categories`} className="border-2 border-[#EFF2F5]">
						<div className="flex justify-between px-3 py-2 bg-[#EFF2F5]">
							<div className="flex gap-3">
								<div className="w-4 h-4 rounded-full" style={{ backgroundColor: categoryColor }} />
								<p className="text-xs font-bold">{categoryName}</p>
							</div>
							<p className="text-xs font-semibold">{totalProyectsByCategory} proyectos</p>
						</div>
						<div className="flex items-center justify-between font-semibold py-[8px] px-3 text-[11px]">
							<p className="w-7/12">Tipo de proyecto</p>
							<p className="text-end w-2/12">Total</p>
							<p className="text-end w-3/12">Porcentaje</p>
						</div>
						<div>{newChild}</div>
					</div>
				);
			})}
		</section>
	);
};
